import { Head, Link } from "@inertiajs/react"
import { ChevronLeft, ExternalLink } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"
import { PostForm, type PostFormData } from "@/components/admin/PostForm"

export default function AdminPostEdit({ post }: { post: PostFormData }) {
  return (
    <>
      <Head title={`Edit — ${post.title}`}>
        <meta name="description" content="Edit a blog post." />
        <meta property="og:title" content="Edit post" />
        <meta property="og:description" content="Edit a blog post." />
      </Head>
      <AdminShell>
        <Link
          href="/admin/posts"
          className="inline-flex items-center gap-1 text-sm text-ink-muted no-underline hover:text-ink-display"
        >
          <ChevronLeft className="h-4 w-4" />
          All posts
        </Link>
        <div className="mt-4 flex items-center justify-between gap-4 border-b border-hairline pb-6">
          <h1>Edit post</h1>
          {post.status === "published" && (
            <a
              href={`/blog/${post.slug}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm text-ink-muted no-underline hover:text-ink-display"
            >
              View <ExternalLink className="h-3.5 w-3.5" />
            </a>
          )}
        </div>
        <PostForm initial={post} />
      </AdminShell>
    </>
  )
}
